import { useMutation, useQueryClient } from '@tanstack/react-query'
import { workspaceChatQueryKeys } from '../queries/chats-query'
import type { ChatApprovalMode } from '@laplace/contracts'
import type { ChatSummary } from '@/features/chats/types/chat'
import { apiClient } from '@/shared/api/client'

interface UpdateChatApprovalModeVariables {
  workspaceId: string
  chatId: string
  approvalMode: ChatApprovalMode
}

export function useUpdateChatApprovalModeMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['workspace-chat', 'approval-mode'],
    mutationFn: ({
      workspaceId,
      chatId,
      approvalMode,
    }: UpdateChatApprovalModeVariables) =>
      apiClient.chats.updateChatApprovalMode(workspaceId, chatId, {
        approvalMode,
      }),
    onSuccess: (chat, variables) => {
      queryClient.setQueryData<Array<ChatSummary>>(
        workspaceChatQueryKeys.list(variables.workspaceId),
        (current) =>
          current?.map((item) => (item.id === chat.id ? chat : item)),
      )
    },
  })
}
